import { ProductContext } from "../../App";
import { useContext } from "react";
import { t } from "i18next";
import information from "../../images/information.svg";

const COLOR_12F = "0xF1EEE7";
const COLOR_18F = "0xEBD9BE";
const COLOR_32F = "0xB7B7B7";
const COLOR_56F = "0x26140E";
const COLOR_30F = "0x9E836C";
const COLOR_6 = "0xf7f9f9";

function Colors() {
  const { currentProduct, currentColor, setCurrentColor } = useContext(ProductContext);

  function selectColor(event) {
    currentProduct.setColor(event.target.id);
    setCurrentColor(event.target.id);
  }

  function displayColorInfo() {
    const infoMessage = document.getElementById('color-info-message');

    if (infoMessage.classList.contains('hidden')) { infoMessage.classList.remove('hidden'); }
    else { infoMessage.classList.add('hidden'); }
  }

  return (
    <section className="panel-container__section">
      <div className="section-header--color section__title">
        {t('recommended_colors')}
        <div className="info">
          <div id="color-info-message" className="info__message hidden">
            <div className="info__message-text">{t('information_colors')}</div>
            <span className="info__message-arrow"></span>
          </div>
          <img
            onMouseEnter={displayColorInfo.bind(this)}
            onMouseLeave={displayColorInfo.bind(this)}
            className="clickable"
            src={information}
            alt="Information sign for accessing informations about recommended colors.">
          </img>
        </div>
      </div>
      <div className="section__color-picker">
        <div className="color-picker__container" id="black">
          <div
            id={COLOR_12F}
            className={`color color--black ${currentColor === COLOR_12F ? "color--selected" : ""}`}
            onClick={selectColor}>
            F 12
          </div>
        </div>
        <div className="color-picker__container" id="dark-gray">
          <div
            id={COLOR_18F}
            className={`color color--dark-gray ${currentColor === COLOR_18F ? "color--selected" : ""}`}
            onClick={selectColor}>
            F 18
          </div>
        </div>
        <div className="color-picker__container" id="light-gray">
          <div
            id={COLOR_32F}
            className={`color color--light-gray ${currentColor === COLOR_32F ? "color--selected" : ""}`}
            onClick={selectColor}>
            F 32
          </div>
        </div>
        <div className="color-picker__container" id="brown">
          <div
            id={COLOR_56F}
            className={`color color--brown ${currentColor === COLOR_56F ? "color--selected" : ""}`}
            onClick={selectColor}>
            F 56
          </div>
        </div>
        <div className="color-picker__container" id="medium-gray">
          <div
            id={COLOR_30F}
            className={`color color--medium-gray ${currentColor === COLOR_30F ? "color--selected" : ""}`}
            onClick={selectColor}>
            F 30
          </div>
        </div>
        {/* <div className="color-picker__container" id="white">
          <div
            id={COLOR_6}
            className={`color color--white ${currentColor === COLOR_6 ? "color--selected" : ""}`}
            onClick={selectColor}>
            001
          </div>
        </div> */}
      </div>
    </section>
  );
}

export default Colors;
